import api from '~/services/api';
import PropTypes from 'prop-types';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'financialexpenses';

// GET
export const getFinancialExpenses = async (params, route = '') => {
  try {
    const { data } = await api.get(`/${endPoint}/${route}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createFinancialExpenses = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateFinancialExpenses = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteFinancialExpenses = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data.data;
  } catch (error) {
    throw error;
  }
};

getFinancialExpenses.propTypes = {
  params: PropTypes.object.isRequired,
};

createFinancialExpenses.propTypes = {
  values: PropTypes.object.isRequired,
};

updateFinancialExpenses.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteFinancialExpenses.propTypes = {
  id: PropTypes.string.isRequired,
};
